/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: TaskMapEncoder
// source: tasks/**

import { TaskExec, TaskIO } from "@pdfking/planner"
import type { StringGUID } from "@pdfking/tfunc"
import type { BatchedItem, T } from "#public"
import type { Array as ArrayType } from "../tasks/Array"
import type { JoinConcurrent as JoinConcurrentType } from "../tasks/JoinConcurrent"
import type { Literal as LiteralType } from "../tasks/Literal"
import type { Preload as PreloadType } from "../tasks/Preload"
import type { Take as TakeType } from "../tasks/Take"

async function* Array(...args: Parameters<typeof ArrayType>) {
  yield* (await import("../tasks/Array")).Array(...args)
}

async function* JoinConcurrent(...args: Parameters<typeof JoinConcurrentType>) {
  yield* (await import("../tasks/JoinConcurrent")).JoinConcurrent(...args)
}

const Literal = (...args: Parameters<typeof LiteralType>) => import("../tasks/Literal").then(({ Literal }) => Literal(...args))

async function* Preload(...args: Parameters<typeof PreloadType>) {
  yield* (await import("../tasks/Preload")).Preload(...args)
}

const Take = (...args: Parameters<typeof TakeType>) => import("../tasks/Take").then(({ Take }) => Take(...args))

export type TasksType = {
  Array: (props: { values: T[]; hash?: StringGUID }) => AsyncGenerator<T>
  JoinConcurrent: (props: Record<string, never>, inputs: AsyncGenerator<T>[]) => AsyncGenerator<BatchedItem<T>>
  Literal: (props: { value: T; hash?: StringGUID }) => Promise<T>
  Preload: (props: Record<string, never>, inputs: AsyncGenerator<T>[]) => AsyncGenerator<T>
  Take: (props: { index: number }, input: AsyncGenerator<T>) => Promise<T>
}

export const TasksDescriptor = {
  Array: { input: TaskIO.ATOM, output: TaskIO.STREAM, exec: TaskExec.INLINE, props: true },
  JoinConcurrent: { input: TaskIO.VECTOR, output: TaskIO.STREAM, exec: TaskExec.INLINE, props: false },
  Literal: { input: TaskIO.ATOM, output: TaskIO.ATOM, exec: TaskExec.INLINE, props: true },
  Preload: { input: TaskIO.VECTOR, output: TaskIO.STREAM, exec: TaskExec.INLINE, props: false },
  Take: { input: TaskIO.STREAM, output: TaskIO.ATOM, exec: TaskExec.INLINE, props: true },
} as const

export const Tasks = {
  Array,
  JoinConcurrent,
  Literal,
  Preload,
  Take,
}
